const { createSelector } = require('reselect')

const selectApppointment = state => state.appointments.appointmentsList

const appointmentsList = () => createSelector(
  [selectApppointment],
  appointment => appointment.data,
)

const appointmentsListError = () => createSelector(
  [selectApppointment],
  appointment => appointment.error,
)

const appointmentsListLoading = () => createSelector(
  [selectApppointment],
  appointment => appointment.loading,
)

const selectApppointmentDetails = state => state.appointments.appointmentDetails

const getAppointmentDetails = () => createSelector(
  [selectApppointmentDetails],
  appointment => appointment.data,
)

const getAppointmentDetailsLoading = () => createSelector(
  [selectApppointmentDetails],
  appointment => appointment.loading,
)

const getAppointmentDetailsError = () => createSelector(
  [selectApppointmentDetails],
  appointment => appointment.error,
)

const selectDoctorAppointmentList = state => state.appointments.doctorAppointmentList

const getDoctorAppointmentList = () => createSelector(
  [selectDoctorAppointmentList],
  appointment => appointment.data,
)

const getDoctorAppointmentListLoading = () => createSelector(
  [selectDoctorAppointmentList],
  appointment => appointment.loading,
)

const getDoctorAppointmentListError = () => createSelector(
  [selectDoctorAppointmentList],
  appointment => appointment.error,
)

const selectdoctorAppointmentOverview = state => state.appointments.doctorAppointmentOverview

const getDoctorAppointmentOverview = () => createSelector(
  [selectdoctorAppointmentOverview],
  appointment => appointment.data,
)

const getDoctorAppointmentOverviewLoading = () => createSelector(
  [selectdoctorAppointmentOverview],
  appointment => appointment.loading,
)

const getDoctorAppointmentOverviewError = () => createSelector(
  [selectdoctorAppointmentOverview],
  appointment => appointment.error,
)

module.exports = {
  appointmentsList,
  appointmentsListError,
  appointmentsListLoading,
  getAppointmentDetails,
  getAppointmentDetailsLoading,
  getAppointmentDetailsError,
  getDoctorAppointmentList,
  getDoctorAppointmentListLoading,
  getDoctorAppointmentListError,
  getDoctorAppointmentOverview,
  getDoctorAppointmentOverviewLoading,
  getDoctorAppointmentOverviewError,
}
